import MeditationNoteByIdRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/MeditationNoteByIdRequest";
import IFilterModel from "@models/IFilterModel";

export default class MeditationNotesFilter implements IFilterModel {
    constructor(obj?: MeditationNotesFilter) {
        if (obj) Object.assign(this, obj);
    }

    MeditationId?: number = null;

    toFilterRequest(): MeditationNoteByIdRequest {
        let self = this;
        return new MeditationNoteByIdRequest({ MeditationId: self.MeditationId });
    }

    resetToDefault(): void {
        this.MeditationId = null;
    }
}